export function checkCheckPoints(file) {
  var isMetadata = file["filename"].indexOf("metadata_") > -1;
  //intentionally choosing here to NOT include the OG metadata file. We want to keep that as a global backup.
  var isXML = file["extension"] === "xml";
  //Only supporting new format going forward.
  var isOC5c = file["extension"] == "oc5c";
  return isOC5c;
}
